import i18n from '@/lang/i18n'

export const TYPES = {
    FUNCTION: 'functions',
    DICT: 'dict',
}

export const ENTITY_TYPES = {
    GPS: 'gps',
    FUNDS: 'funds',
    FUNDS_PERF: 'funds-perf',
    COMPANIES: 'companies',
    COMPANIES_EVOL: 'companies-evol',
    TRANSACTIONS: 'trans',
    TRANSACTIONS_PERF: 'trans-perf',
    LPS: 'lps',
    LPS_INVESTMENTS: 'lps-investments',
    LPS_SECONDARY_TRANS: 'lps-secondary-trans',
}

export const ENTITIES_BY_ID = {
    [ENTITY_TYPES.GPS]: {
        path: ENTITY_TYPES.GPS,
        name: 'GPs',
        label: i18n.t('admin.navigation.schema.gps'),
        icon: 'folder',
        color: 'turquoise',
    },
    [ENTITY_TYPES.FUNDS]: {
        path: ENTITY_TYPES.FUNDS,
        name: 'Funds',
        label: i18n.t('admin.navigation.schema.funds'),
        icon: 'folder',
        color: 'cyan',
    },
    [ENTITY_TYPES.FUNDS_PERF]: {
        path: ENTITY_TYPES.FUNDS_PERF,
        name: 'FundsPerf',
        label: i18n.t('admin.navigation.schema.fundsPerf'),
        icon: 'folder',
        color: 'cyan',
    },
    [ENTITY_TYPES.COMPANIES]: {
        path: ENTITY_TYPES.COMPANIES,
        name: 'Companies',
        label: i18n.t('admin.navigation.schema.companies'),
        icon: 'folder',
        color: 'pink',
    },
    [ENTITY_TYPES.COMPANIES_EVOL]: {
        path: ENTITY_TYPES.COMPANIES_EVOL,
        name: 'CompaniesEvol',
        label: i18n.t('admin.navigation.schema.companiesEvol'),
        icon: 'folder',
        color: 'pink',
    },
    [ENTITY_TYPES.TRANSACTIONS]: {
        path: ENTITY_TYPES.TRANSACTIONS,
        name: 'Trans',
        label: i18n.t('admin.navigation.schema.trans'),
        icon: 'folder',
        color: 'violet',
    },
    [ENTITY_TYPES.TRANSACTIONS_PERF]: {
        path: ENTITY_TYPES.TRANSACTIONS_PERF,
        name: 'TransPerf',
        label: i18n.t('admin.navigation.schema.transPerf'),
        icon: 'folder',
        color: 'violet',
    },
    [ENTITY_TYPES.LPS]: {
        path: ENTITY_TYPES.LPS,
        name: 'Lps',
        label: i18n.t('admin.navigation.schema.lps'),
        icon: 'folder',
        color: 'cyan',
    },
    [ENTITY_TYPES.LPS_INVESTMENTS]: {
        path: ENTITY_TYPES.LPS_INVESTMENTS,
        name: 'LpsInvestments',
        label: i18n.t('admin.navigation.schema.lpsInvestments'),
        icon: 'folder',
        color: 'cyan',
    },
    [ENTITY_TYPES.LPS_SECONDARY_TRANS]: {
        path: ENTITY_TYPES.LPS_SECONDARY_TRANS,
        name: 'LpsSecondaryTrans',
        label: i18n.t('admin.navigation.schema.lpsSecondaryTrans'),
        icon: 'folder',
        color: 'cyan',
    },
}

export const ENTITIES = [
    ENTITIES_BY_ID[ENTITY_TYPES.GPS],
    ENTITIES_BY_ID[ENTITY_TYPES.FUNDS],
    ENTITIES_BY_ID[ENTITY_TYPES.FUNDS_PERF],
    ENTITIES_BY_ID[ENTITY_TYPES.COMPANIES],
    ENTITIES_BY_ID[ENTITY_TYPES.COMPANIES_EVOL],
    ENTITIES_BY_ID[ENTITY_TYPES.TRANSACTIONS],
    ENTITIES_BY_ID[ENTITY_TYPES.TRANSACTIONS_PERF],
    ENTITIES_BY_ID[ENTITY_TYPES.LPS],
    ENTITIES_BY_ID[ENTITY_TYPES.LPS_INVESTMENTS],
    ENTITIES_BY_ID[ENTITY_TYPES.LPS_SECONDARY_TRANS],
]

export default ENTITIES
